import React, { useEffect, useState } from "react";
import "./index.less";
import { Badge, Menu } from "antd";
import {
    AddFriendIcon,
    FriendGroupIcon,
    FriendAllGroupIcon,
    FriendRelationGroupIcon,
} from "../../SvgIconCom/FriendsChatIcon";
import { useTranslate } from "@obsbot/remo-i18n";
import { FriendItem, useFriendStore } from "@obsbot/remo-stores";
import { useLocation } from "react-use";
import { RelationShip } from "remo-types/src/constants";
interface GroupProps {
    online: number;
    all: number;
    relation: number;
    addFriend: number;
}

interface labelProps {
    text: string;
    num: number;
}

export interface GroupListProps {
    selectedGroup?: boolean;
    isSelectedClick?: () => void; // Optional click event handler function
    onClick?: (key: string, userCount: number) => void;
}
const LabelCom: React.FC<labelProps> = ({ text, num = 0 }) => (
    <div className="label-com">
        <span className="label-com-text">{text}</span>
        <span className="label-com-num">{num}</span>
    </div>
);
export const GroupList: React.FC<GroupListProps> = ({
    selectedGroup = false,
    onClick,
    isSelectedClick,
}) => {
    const location = useLocation();
    const [selectedKeys, setSelectedKeys] = useState(
        selectedGroup ? ["AddFriendsPage"] : undefined,
    );
    const { friendList, application } = useFriendStore();
    const [groupNumber, setGroupNumber] = useState<GroupProps>({
        online: 0,
        all: 0,
        relation: 0,
        addFriend: 0,
    });
    const t = useTranslate(); // Use the useTranslate hook to get the translation function

    const menuItems = [
        {
            label: <LabelCom num={groupNumber.online} text={t("chat.online", { user: "" })} />,
            key: "OnlineFriendsPage",
            icon: <FriendGroupIcon selected={selectedKeys?.includes("OnlineFriendsPage")} />,
        },
        {
            label: <LabelCom num={groupNumber.all} text={t("chat.all", { user: "" })} />,
            key: "AllFriendsPage",
            icon: <FriendAllGroupIcon selected={selectedKeys?.includes("AllFriendsPage")} />,
        },
        {
            label: <LabelCom num={groupNumber.relation} text={t("chat.relationship")} />,
            key: "RelationshipPage",
            icon: <FriendRelationGroupIcon selected={selectedKeys?.includes("RelationshipPage")} />,
        },
        {
            label: (
                <Badge count={groupNumber.addFriend} dot={true} offset={[2, -2]}>
                    {t("chat.add-friend")}
                </Badge>
            ),
            key: "AddFriendsPage",
            icon: <AddFriendIcon selected={selectedKeys?.includes("AddFriendsPage")} />,
        },
    ];
    useEffect(() => {
        const hash = location.hash;
        const curGroup = hash?.split("/")[2];
        switch (curGroup) {
            case "online-friends": {
                setSelectedKeys(["OnlineFriendsPage"]);
                break;
            }
            case "all-friends": {
                setSelectedKeys(["AllFriendsPage"]);
                break;
            }
            case "relationship": {
                setSelectedKeys(["RelationshipPage"]);
                break;
            }
            case "add-friends": {
                setSelectedKeys(["AddFriendsPage"]);
                break;
            }
            default: {
                setSelectedKeys(undefined);
            }
        }
    }, [location]);

    useEffect(() => {
        const relationNum = friendList.reduce((sum: number, cur: FriendItem) => {
            const curGroupList = cur.groupList;
            if (curGroupList.includes(RelationShip.BosomFriend)) {
                sum++;
            } else if (curGroupList.includes(RelationShip.Buddy)) {
                sum++;
            } else if (curGroupList.includes(RelationShip.Lovers)) {
                sum++;
            }
            return sum;
        }, 0);
        const onlineNum = friendList.filter(
            item =>
                item.profile.profileCustomField.filter(
                    e => e.key === "Tag_Profile_Custom_Status",
                )[0]?.value === "online",
        ).length;
        setGroupNumber({
            online: onlineNum || 0,
            all: friendList?.length ?? 0,
            relation: relationNum,
            addFriend: application.unreadCount,
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [friendList, application]);

    const handleSelect = ({ key }: { key: string }): void => {
        setSelectedKeys([key]);
        isSelectedClick && isSelectedClick(); // 用于切换选中状态
        onClick && onClick(key, getCurGroupNumber(key));
    };

    const getCurGroupNumber = (key: string): number => {
        switch (key) {
            case "OnlineFriendsPage": {
                return groupNumber.online;
            }
            case "AllFriendsPage": {
                return groupNumber.all;
            }
            default: {
                return 0;
            }
        }
    };
    return (
        <div className="group-list">
            <Menu items={menuItems} selectedKeys={selectedKeys} onSelect={handleSelect}></Menu>
        </div>
    );
};
